<template>
    <main-section>
        <v-layout column justify-center align-center>
            <v-sheet class="d-flex flex-column align-center">
                <v-icon size="80" class="mb-10 mb-lg-20 primary--text">mdi-close-octagon-outline</v-icon>
                <v-sheet class="text-center mb-20 mb-lg-40">
                    <h3 class="tit mb-8 mb-lg-16">접근 불가</h3>
                    <p class="page-text--lg grey-6--text">
                        <template v-if="!!lecture?.subject"> "{{ lecture?.subject }}" </template>
                        <template v-else> 해당</template>
                        교육 서비스에 대한 접근이 불가능합니다.
                    </p>
                </v-sheet>
                <div class="v-btn-group mt-0">
                    <v-btn color="primary" class="min-w-140px min-w-lg-160px" @click="exit"><span>뒤로가기</span></v-btn>
                </div>
            </v-sheet>
        </v-layout>
    </main-section>
</template>

<script>
import { mapState } from "vuex";
import MainSection from "@/components/client/main/main-section.vue";

export default {
    components: {
        MainSection,
    },
    computed: {
        ...mapState("lecture", ["lecture", "isAccessible"]),
    },
    methods: {
        exit() {
            this.$router.go(-1);
        },
    },
};
</script>

<style>
</style>